import script from "./setting-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./setting-dialog.vue?vue&type=script&lang=ts&setup=true"

import "./setting-dialog.vue?vue&type=style&index=0&id=517f4b0a&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-517f4b0a"]])

export default __exports__